/* -----------------------------------------------------------------------------------------------------
  - Created: [20-02-2025] by [SREERAJ]
  - Modified: [YYYY-MM-DD] 
  - Description: This file contains the Employee technology search filter component
------------------------------------------------------------------------------------------------------- */

import React from 'react';
import { useFormik } from 'formik';
import './TechnologySearchFilterStyle.css';
import CustomAddButton from '../../../../Components/custom_components/CustomAddButton/CustomAddButton';
import CustomBreadcrumbs from '../../../../Components/custom_components/CustomBreadcrumbs/CustomBreadcrumbs';
import Grid from '@mui/material/Grid2';
import ActionButton from '../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';
import { CiSearch } from 'react-icons/ci';
import CustomTextFieldWithIcon from '../../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon';
import { statusOptions } from '../../../../utils/constants';
import CustomSelectDropdown from '../../../../Components/custom_components/CustomSelectDropdown/CustomSelectDropdown';


function TechnologySearchFilter({ searchFilter, isAddPermission, tableTitle, isAddEdiModalOpen, handleAddEditModal, on_change_value, on_page_count_update }) {
    const breadcrumbs = ['Resources', tableTitle]
    const handlemodal = () => {
        handleAddEditModal(!isAddEdiModalOpen);
    }

    const formik = useFormik({
        initialValues: {
            status: '',
            TechnologiesName: '',
            TechnologiesShortCode: '',
        },
        // onSubmit: (values) => {
        //     searchFilter(values)
        // },
    });

    const resetFilter = () => {

        on_change_value(1)
        on_page_count_update(25)

        formik.setValues({
            status: '',
            TechnologiesShortCode: '',
            TechnologiesName: ''
        });
        searchFilter({
            status: '',
            TechnologiesShortCode: '',
            TechnologiesName: '',
        })
    };

    return (
        <div className="technology-lookup-search-container">
            <div className="technology-lookup-search-sub-container">
                <div className="technology-lookup-search-header">
                    <div className="technology-lookup-search-left">
                        <div className="technology-table-title">{tableTitle}</div>
                        <CustomBreadcrumbs breadcrumbs={breadcrumbs} />
                    </div>
                    <div className="technology-lookup-search-right">
                        {isAddPermission && <CustomAddButton label="Add" onClick={handlemodal} />}
                    </div>
                </div>
                <div className="search-layout-wrapper">
                    <div className="search-filter-container">
                        <div className="search-inputs-fields">
                            {/* First Grid item: Filters */}
                            <Grid item xs={12} sm={6} md={2}>
                                <CustomTextFieldWithIcon
                                    id='TechnologiesName'
                                    name='TechnologiesName'
                                    placeholder='Search by Name'
                                    value={formik?.values?.TechnologiesName}
                                    onChange={formik.handleChange}
                                    StartIcon={CiSearch}
                                    width="200px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>
                                <CustomTextFieldWithIcon
                                    id='TechnologiesShortCode'
                                    name='TechnologiesShortCode'
                                    placeholder='Search by Code'
                                    value={formik?.values?.TechnologiesShortCode}
                                    onChange={formik.handleChange}
                                    StartIcon={CiSearch}
                                    width="200px"
                                />
                            </Grid>

                            <Grid item xs={12} sm={6} md={2}>

                                <CustomSelectDropdown
                                    name="status"
                                    placeholder="Select Status"
                                    options={statusOptions}
                                    value={statusOptions?.find(option => option?.value === formik?.values?.status) || ""}
                                    onChange={(selectedOption) => {
                                        formik.setFieldValue("status", selectedOption ? selectedOption.value : "");
                                    }}
                                    onBlur={formik.handleBlur}
                                    isDisabled={false}
                                    isMulti={false} // Set to false for single-select
                                    width="200px"
                                />
                            </Grid>
                        </div>
                        {/* Search Button */}
                        <div className="search-buttons-fixed-right">
                            <ActionButton
                                onClick={() => {
                                    on_change_value(1)
                                    searchFilter({ ...formik.values }); // Always trigger search, even if no values changed
                                }}
                                btnDisable={false}
                                label="Search"
                                btnType="primary"
                            />
                            <ActionButton label="Reset" btnType="outlined" onClick={resetFilter} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TechnologySearchFilter;
